import { render } from "./CustomerReference.vue?vue&type=template&id=37cb08be"
import script from "./CustomerReference.vue?vue&type=script&lang=js"
export * from "./CustomerReference.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__